export enum EPermissionDeviceTypes {
  Microphone = 'microphone',
  Camera = 'camera',
}

export enum EPermissionValue {
  Denied = 'denied',
  Prompt = 'prompt',
  Granted = 'granted',
}

export type TPermissionDeviceTypes =
  | EPermissionDeviceTypes.Camera
  | EPermissionDeviceTypes.Microphone;

export type TPermissionValue =
  | EPermissionValue.Denied
  | EPermissionValue.Prompt
  | EPermissionValue.Granted;

export type TPermissionsInfo = {
  [M in TPermissionDeviceTypes]: {
    [N in TPermissionValue]: {
      title: string;
      subtitle: string;
      icon: string;
    } | null;
  };
};
